import { OpportunitiesRoomLayout } from './components/OpportunitiesRoomLayout';
import { OpportunityDetail } from '@/features/social-media-opportunities-widget/ui/components/OpportunityDetail';
import { useSocialMediaOpportunitiesStore } from '@/features/social-media-opportunities-widget/model/social-media-opportunities-widget.store';
import type { SocialMediaOpportunitiesDeps } from '@/features/social-media-opportunities-widget';
import { useStartInterview } from '@/features/audiences';

export function OpportunitiesRoom() {
  const setSelectedItem = useSocialMediaOpportunitiesStore((state) => state.setSelectedItem);

  const detailDeps = {
    useStartInterview: () =>
      useStartInterview() as unknown as ReturnType<
        SocialMediaOpportunitiesDeps['useStartInterview']
      >,
  };

  return (
    <OpportunitiesRoomLayout
      renderDetail={(item, onClose) => (
        <OpportunityDetail
          item={item as Parameters<typeof setSelectedItem>[0]}
          onClose={onClose}
          deps={detailDeps}
        />
      )}
      onSelectItem={(item) => setSelectedItem(item as Parameters<typeof setSelectedItem>[0])}
    />
  );
}
